module.exports = __webpack_public_path__ + "img/geofence.5d1c6a19.jpg";